import { useEffect, useRef } from 'react';
import { useHeightObserver } from './useHeightObserver';
import { getPerformanceMark, usePerformanceAnalytics } from '../../hooks/usePerformanceAnalytics';
import { PERFORMANCE_ANALYTICS_INTERVAL } from '../../provider/PerformanceAnalytics';

export const useResizeAnalytics = ({ isEnabled }: { isEnabled: boolean }) => {
	const { captureEvent } = usePerformanceAnalytics({
		isEnabled,
	});
	const { containerRef, height } = useHeightObserver();
	const isTracking = useRef(true);

	useEffect(() => {
		// Stop tracking after 10 seconds
		const timeoutId = setTimeout(() => {
			isTracking.current = false;
		}, PERFORMANCE_ANALYTICS_INTERVAL);

		return () => clearTimeout(timeoutId);
	}, []);

	useEffect(() => {
		if (height !== null && isEnabled && isTracking.current) {
			isTracking.current = true;
			captureEvent({
				type: 'resized',
				height,
				elapsed: getPerformanceMark(),
			});
		}
	}, [height, isEnabled, captureEvent]);

	return { containerRef };
};
